<ng-container>
  <textarea
    [disabled]="disabled"
    nz-col
    nzSpan="19"
    nz-input
    [ngModel]="value"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="writeValue($event)"
    [disabled]="disabled"
    placeholder=""
    [nzAutosize]="{ minRows: 2, maxRows: 6 }"
    (blur)="onFieldBlur($event)"
  ></textarea>
  <a
    nz-button
    [nzLoading]="aiLoading"
    style="margin-top: 10px"
    *ngIf="
      field.AdditionalData != null &&
      field.AdditionalData.useAiGeneration != null &&
      field.AdditionalData.useAiGeneration === true &&
      field.AdditionalData.aigenerationQuestion != null
    "
    class="ai-icon"
    (click)="aiLoading === false ? getAIText() : null"
  >
    <span>{{'Generate Text with AI'  | translate}}</span>
  </a>
</ng-container>
